import React from 'react';
import { enums, Panel, Label } from 'console-kit';

const CSSHelp = () => (
  <Panel
    header="CSS Help"
    hasBorder={false}
    padding={{
      vertical:   enums.sizes.X4,
      horizontal: enums.sizes.X4,
    }}
  >
    <div className="help-info-column__content">
      <Label text="Please copy the embed code and place it on your website inside of the <head> tag." />
    </div>
  </Panel>
);

export default CSSHelp;
